/*
 * Card de catálogo — Ariel Malhas
 * Seletor de quantidade (variante B). Usa delegação de eventos, então
 * funciona também para cards carregados dinamicamente (filtros/carrossel).
 */
(function () {
  'use strict';

  function stepQuantity(input, delta) {
    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = 1;
    value = Math.max(1, value + delta);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    if (!up && !down) return;
    e.preventDefault();
    var wrap = (up || down).closest('.acard__qty');
    if (!wrap) return;
    var input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    stepQuantity(input, up ? 1 : -1);
  });

  // Mantém apenas dígitos no campo de quantidade.
  document.addEventListener('input', function (e) {
    if (!e.target.closest) return;
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var cleaned = input.value.replace(/[^0-9]/g, '');
    if (cleaned !== input.value) input.value = cleaned;
  });

  // Garante mínimo de 1 ao sair do campo.
  document.addEventListener('blur', function (e) {
    if (!e.target.closest) return;
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    if (!input.value || parseInt(input.value, 10) < 1) input.value = 1;
  }, true);
})();
